import React, { useCallback, useEffect } from "react";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";

import "./HeroComponent.scss";

const VideoBg = () => {
	let myScrollFunc = useCallback(() => {
		let y = window.scrollY;
		if (y >= 540 && window.innerWidth <= 425) {
			document.querySelector("#btn").style.opacity = "1";
			document.querySelector("#btn").style.display = "block";
		} else {
			// document.querySelector("#btn").style.opacity = "0";
			document.querySelector("#btn").style.display = "none";
		}
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", myScrollFunc);
		return () => {
			window.removeEventListener("scroll", myScrollFunc);
		};
	}, [myScrollFunc]);

	return (
		<>
			<div className='Video-Wrapper'>
				<video autoPlay loop muted className='Video-Wrapper__BG'>
					<source src='https://storage.googleapis.com/cp-prod-assets-public-as-sth1-gcs-w37fpj/Careers%20Page_Clip_1_Compressed.mp4' />
				</video>
				<main className='Video-Wrapper__main'>
					<h1 className='Video-Wrapper__hero'>
						We{" "}
						<Typewriter
							options={{
								strings: ["Create", "Collaborate", "Celebrate"],
								autoStart: true,
								loop: true,
							}}
						/>
					</h1>
					<Link
						to={{ pathname: "/open-role", state: "/careers" }}
						style={{ textDecoration: "none" }}
					>
						<button className='Video-Wrapper__cta'>See Open Roles</button>
					</Link>
				</main>
				{/* <div className='Video-Wrapper__overlay'></div> */}
			</div>

			<div className='seeOpenRoles' id='btn'>
				<Link to={{ pathname: "/open-role", state: "/careers" }}>
					<button>See Open Roles</button>
				</Link>
			</div>
		</>
	);
};

export default VideoBg;
